import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { PERIOD_HOURS_FIELD_MAP } from './useAllocateResourcePopupHandler';

export const useAllocateResourcePeriodError = () => {
  const { formatMessage } = useIntl();
  const {
    errors,
    touched,
    values: { selectedAllocationPeriod, showAdvancedSettings, user }
  } = useFormikContext();

  const activeFieldName = PERIOD_HOURS_FIELD_MAP[selectedAllocationPeriod];

  const allocationError =
    showAdvancedSettings &&
    user &&
    touched[activeFieldName] &&
    errors[activeFieldName]
      ? formatMessage({ id: errors[activeFieldName] })
      : null;

  return {
    allocationError,
    entirePeriodDisabled: showAdvancedSettings && !user
  };
};

export default useAllocateResourcePeriodError;
